export enum StorageKey {
  ALLOW_PUSH_NOTIF = "blacknut:allowPushNotif",
  API_VERSION = "blacknut:apiVersion",
  AUDID = "blacknut:audid",
  DEVICE_ID = "blacknut:deviceId",
  INCUBATING_FEATURES = "blacknut:incubating",
  INSTALL_NOTIF = "blacknut:installNotif",
  LOCALE = "blacknut:locale",
  NEW_USER = "blacknut:newUser",
  PERFORMANCE_MONITORING = "blacknut:performanceMonitoring",
  PLATFORM = "blacknut:platform",
  PRESHIPPING_ID = "blacknut:preshippingId",
  PROFILES_DATA = "blacknut:profilesData",
  RTP_DELAY = "blacknut:rtpDelay",
  SHOW_FPS = "blacknut:showFps",
  SKIP_GAMEPAD_CHECK = "blacknut:skipGamepadCheck",
  SPEED_TEST_RESULT = "blacknut:speedtest",
  START_URL = "blacknut:startUrl",
  STATS_4_NERDS = "blacknut:stats4Nerds",
  STREAM_MUTED = "blacknut:streamMute",
  SUBSCRIBED = "blacknut:subscribed",
  THEME_BW = "blacknut:theme",
  TOKEN = "blacknut:user:token",
  TV_LEGACY = "blacknut:TVLegacy",
  UDP_OPTION = "blacknut:udpOptions",
  UPDATE_AVAILABLE = "blacknut:UpdateAvailable",
  VERSION = "blacknut:version",
  WARMUP_VIDEO = "blacknut:warmupVideo",
  WINDOWED = "blacknut:windowed",
  WS_PLATFORM = "blacknut:wsplatform",
  FEAT_WEBOS10YRS = "feat:webos10yrs",
  FEAT_TRYBUY = "feat:blacknutTryBuy",
  VIRTUAL_KEYBOARD = "blacknut:virtualKeyboard",
  LOGS_OVERLAY = "blacknut:logsOverlay",
}

/** @deprecated */
export enum DeprecatedStorageKey {
  TOKEN = "blacknut:user:tokenFamily",
  GSTREAMER_OPTION = "blacknut:gStreamerOption",
  GSTREAMER_AUDIO_PORT = "blacknut:gStreamerAudioPort",
  GSTREAMER_LOG_FORMAT = "blacknut:gStreamerLogFormat",
  DEBUG = "blacknut:debug",
  PLAYER_DEBUG = "blacknut:player:debug",
  PLAYER_INPUT_METHOD = "blacknut:playerInputMethod",
  PROTOCOL = "blacknut:protocol",
  TV_VIRTUAL_KEYBOARD = "blacknut:TvVirtualKeyboard",
}

export interface IStorageService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getItem(key: StorageKey | DeprecatedStorageKey): Promise<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setItem(key: StorageKey | DeprecatedStorageKey, value: unknown): Promise<any>;
  removeItem(key: StorageKey | DeprecatedStorageKey): Promise<void>;
}
